import { useLayoutEffect, useState } from 'react';

export const toScreen = (host, svg, view, wx, wy) => { const r = svg.current.getBoundingClientRect(), h = host.current.getBoundingClientRect(), span = 600 / view.zoom; return { x: r.left - h.left + (wx - view.x) / span * r.width, y: r.top - h.top + (wy - view.y) / span * r.height, scale: r.width / span }; };

export const usePlacement = (host, svg, view, size, wx, wy, layout = 0) => {
  const [pos, setPos] = useState(null);
  useLayoutEffect(() => { if (svg.current && host.current) setPos(toScreen(host, svg, view, wx, wy)); }, [host, svg, view, size, wx, wy, layout]);
  return pos;
};
